import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=c4c596c2&scoped=true&"
import script from "./LinkList.vue?vue&type=script&lang=js&"
export * from "./LinkList.vue?vue&type=script&lang=js&"
import style0 from "./LinkList.vue?vue&type=style&index=0&id=c4c596c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c596c2",
  null
  
)

export default component.exports